export var MPARequestStatus;
(function (MPARequestStatus) {
    MPARequestStatus["MPA_REQUEST_STATUS_PENDING_APPROVAL"] = "PENDING_APPROVAL";
    MPARequestStatus["MPA_REQUEST_STATUS_APPROVED"] = "APPROVED";
    MPARequestStatus["MPA_REQUEST_STATUS_DENIED"] = "DENIED";
    MPARequestStatus["MPA_REQUEST_STATUS_EXPIRED"] = "EXPIRED";
    MPARequestStatus["MPA_REQUEST_STATUS_EXECUTED"] = "EXECUTED";
    MPARequestStatus["MPA_REQUEST_STATUS_CANCELLED"] = "CANCELLED";
})(MPARequestStatus || (MPARequestStatus = {}));
